export default {"src":"https://web.cdn.greenlight.com/2.481.0/_next/static/media/link-icon.f6158122.svg","height":19,"width":19};